import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeComponent } from './common/pages/home/home.component';
import { CompetitionDetailsComponent } from './common/components/navigation-bar/competitions/competition-details/competition-details.component';
import { ActivateComponent } from './common/components/activate/activate.component';
import { SeasonResultsTableComponent } from './common/components/season-management/season-results-table/season-results-table.component';
import { CompetitionAuthorGuard } from './controls/guards/competition-author.guard';
import { competitionAuthorResolver } from './common/components/navigation-bar/competitions/competition-details/registered-crews-table/resolvers/competition-author.resolver';
import { SeasonSpeedTrialResultsTableComponent } from './common/components/season-management/season-stage-results-table/season-speed-trial-results-table.component';
import { StageResultsTableComponent } from './common/components/stage-result/components/list/stage-results-table.component';
import { adminResolver } from './common/components/navigation-bar/competitions/competition-details/registered-crews-table/resolvers/admin.resolver';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: HomeComponent,
        },
        {
          path: 'competition/add',
          loadComponent: () =>
            import(
              './common/components/competition-management/edit-competition-card/competition-card.component'
            ).then((component) => component.CompetitionCardComponent),
        },
        {
          path: 'competition/:id',
          loadComponent: () =>
            import(
              './controls/page-wrapper/page-wrapper.component'
            ).then((component) => component.PageWrapperComponent),
          data: { breadcrumb: 'Edit competition' },
          children: [
            {
              path: '',
              loadComponent: () =>
                import(
                  './common/components/competition-management/edit-competition-card/competition-card.component'
                ).then((component) => component.CompetitionCardComponent),
              canActivate: [CompetitionAuthorGuard],
            },
            {
              path: 'registered-crews',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/navigation-bar/competitions/competition-details/registered-crews-table/components/registered-crews-table.component'
                ).then((component) => component.RegisteredCrewsTableComponent),
              data: { breadcrumb: 'Registered crews' },
            },
            {
              path: 'stage/:stageId/driving-reports/add',
              loadComponent: () =>
                import(
                  './common/components/driving-report/components/detail/driving-report.component'
                ).then((component) => component.DrivingReportComponent),
              data: { breadcrumb: 'Driving report' },
              resolve: { isOrganizer: competitionAuthorResolver },
              canActivate: [CompetitionAuthorGuard],
            },
            {
              path: 'stage/:stageId/crew/:crewNumber/driving-report/:drivingReportId/edit',
              loadComponent: () =>
                import(
                  './common/components/driving-report/components/detail/driving-report.component'
                ).then((component) => component.DrivingReportComponent),
              data: { breadcrumb: 'Driving report' },
              resolve: { isOrganizer: competitionAuthorResolver },
              canActivate: [CompetitionAuthorGuard],
            },
            {
              path: 'stage/:stageId/crew/:crewNumber/driving-report/:drivingReportId/display',
              loadComponent: () =>
                import(
                  './common/components/driving-report/components/detail/driving-report.component'
                ).then((component) => component.DrivingReportComponent),
              data: { breadcrumb: 'Driving report' },
              resolve: { isOrganizer: competitionAuthorResolver },
            },
            {
              path: 'round/:roundId/add-stage',
              loadComponent: () =>
                import(
                  './common/components/competition-management/edit-competition-card/edit-stage-card/stage-card.component'
                ).then((component) => component.StageCardComponent),
              data: { breadcrumb: 'Stage card' },
              canActivate: [CompetitionAuthorGuard],
            },
            {
              path: 'round/:roundId/stage/:stageId/edit',
              loadComponent: () =>
                import(
                  './common/components/competition-management/edit-competition-card/edit-stage-card/stage-card.component'
                ).then((component) => component.StageCardComponent),
              data: { breadcrumb: 'Stage card' },
              canActivate: [CompetitionAuthorGuard],
            },
            {           
              path: 'stage/:stageId/driving-reports',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/driving-report/components/list/components/driving-reports-table.component'
                ).then((component) => component.DrivingReportsTableComponent),
              data: { breadcrumb: 'Driving reports' },
            },
            {           
              path: 'stage/:stageId/results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/stage-result/components/list/stage-results-table.component'
                ).then((component) => component.StageResultsTableComponent),
              data: { breadcrumb: 'Stage results' },
            },
            {
              path: 'stage/:stageId/speed-trial/results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/stage-result/components/speed-trial-list/speed-trial-results-table.component'
                ).then((component) => component.SpeedTrialResultsTableComponent),
              data: { breadcrumb: 'Stage speed trial results' },
            },
            {           
              path: 'round/:roundId/results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/round-result/components/round-results-table.component'
                ).then((component) => component.RoundResultsTableComponent),
              data: { breadcrumb: 'Round results' },
            },
            {
              path: 'round/:roundId/speed-trial/results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/stage-result/components/speed-trial-list/speed-trial-results-table.component'
                ).then((component) => component.SpeedTrialResultsTableComponent),
              data: { breadcrumb: 'Round speed trial results' },
            },
            {           
              path: 'results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/competition-result/components/competition-results-table.component'
                ).then((component) => component.CompetitionResultsTableComponent),
              data: { breadcrumb: 'Competition results' },
            },
            {
              path: 'speed-trial/results',
              resolve: { isOrganizer: competitionAuthorResolver },
              loadComponent: () =>
                import(
                  './common/components/stage-result/components/speed-trial-list/speed-trial-results-table.component'
                ).then((component) => component.SpeedTrialResultsTableComponent),
              data: { breadcrumb: 'Competition speed trial results' },
            },
          ]
        },
        {
          path: 'season/:id/:name/registered-crews',
          loadComponent: () =>
            import(
              './common/components/annual-registration/components/list/annual-registered-crews-table.component'
            ).then((component) => component.AnnualRegisteredCrewsTableComponent),
        },
        {
          path: 'season/:id/results',
          resolve: { isOrganizer: adminResolver },
          loadComponent: () =>
            import(
              './common/components/season-management/season-results-table/season-results-table.component'
            ).then((component) => component.SeasonResultsTableComponent),
        },
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'home', component: HomeComponent },
        {
          path: 'season/:seasonId/:type/speed-trial/results',
          component: SeasonSpeedTrialResultsTableComponent,
        },
        // {path: 'competition/:competitionId/stage/:stageId/crew/:crewNumber/driving-report/:id', component: DrivingReportDetailedComponent},
        { path: 'competition-details', component: CompetitionDetailsComponent },
        { path: 'account/activate', component: ActivateComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload' }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
